import { onValue, ref, get, off } from "firebase/database";
import { createContext, useEffect, useState } from "react";
import { realTimeDB } from "./firebase";
import { sanitizeText } from "./newComponents/GeneralClasses";

export const AuthContext = createContext();
export const AuthContextProvider = ({children}) => {
  const [uid,setUserCode]=useState("");
  const [userName,setUserName]=useState("");
  const [user_email,setUser_email]=useState("");
  const [profile_pic,setProfile_pic]=useState("");
  const [bloggerid,setBloggerid]=useState("");
  const [verifiedUid,setVerifiedUid]=useState(false);
  const [userStatus,setUserStatus]=useState("");
  const [userBlocked, setUserBlocked] = useState(false);
  const [existingUser, setExistingUser] = useState(false);


  useEffect(()=>{

    if(localStorage.getItem("userCode") !== null){
      const user_id = localStorage.getItem("userCode");
      setUserCode(user_id);
    }
    if(localStorage.getItem("userName") !== null){
      const user_name = localStorage.getItem("userName");
      setUserName(user_name);
    }
    if(localStorage.getItem("userEmail") !== null){
      const email = localStorage.getItem("userEmail");
      setUser_email(email);
      setExistingUser(true);
    }
    if(localStorage.getItem("userCode") !== null && localStorage.getItem("userCode") !== ""){
      const dp = localStorage.getItem("userProfile");
      setProfile_pic(dp);
    }else{
      setProfile_pic("");
    }
    if(localStorage.getItem("bloggerid") !== null){
      const bloggerid = localStorage.getItem("bloggerid");
      setBloggerid(bloggerid);
    }

    const user_ref = localStorage.getItem("userEmail");

    const userSnapshot = ref(realTimeDB,`${process.env.REACT_APP_USERSREF}/${sanitizeText(user_ref)}`);
     const listener = onValue(userSnapshot,(snapshot)=>{
            if(snapshot.exists()){
              setVerifiedUid(true);
            }else {
              setVerifiedUid(false);
            }
      });

    const userBlockedSnapshot = ref(realTimeDB,`${process.env.REACT_APP_BLOCKED_USERS}/${sanitizeText(user_ref)}`);
     const listener2 = onValue(userBlockedSnapshot,(snapshot)=>{
            if(snapshot.exists()){
              setVerifiedUid(false);
              setUserBlocked(true);
            }else {
              setUserBlocked(false);
            }
      });

    async function getUserProfilePicInRealtime(){
      const profilePicRef = await get(ref(realTimeDB, `${process.env.REACT_APP_USERSREF}/${sanitizeText(user_ref)}/profile_pic`));
      if (profilePicRef.exists()) {
            setProfile_pic(profilePicRef.val());
      }else{
        setProfile_pic("");
      }
    };

    async function getUserStatus() {
       const userStatusRef = await get(ref(realTimeDB, `${process.env.REACT_APP_USERSREF}/${sanitizeText(user_ref)}/status`));
      if (userStatusRef.exists()) {
        const userStatusCode = userStatusRef.val();
        setUserStatus(userStatusCode);
      }else{
        setUserStatus("");
      }
    };
    getUserProfilePicInRealtime();
    getUserStatus();
    return()=>{
      off(userSnapshot,"value",listener);
      off(userBlockedSnapshot, "value" ,listener2);
    }

  },[verifiedUid]);

  

   return(
    <AuthContext.Provider value={{
      uid,
      userName,
      user_email,
      profile_pic,
      bloggerid,
      verifiedUid,
      userBlocked,
      existingUser,
      userStatus
    }}>
    {children}
  </AuthContext.Provider>
   );
};